import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/_services/user.service';
import { DataService } from '../_services/data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { Subject, takeUntil } from 'rxjs';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe
@Component({
  selector: 'app-hamburger-nav',
  templateUrl: './hamburger-nav.component.html',
  styleUrls: ['./hamburger-nav.component.scss']
})
export class HamburgerNavComponent {
  constructor(private router: Router, private userService: UserService, private dataService: DataService, private globalService: GlobalService, private translate: TranslateService, private amplitudesService: AmplitudeService
  ) {

  }

  activeModule: string;
  isExpanded: boolean = true;
  userPlan;
  currLang;
  tabs = [];
  BusesTabItems = [];
  SchoolManagementTabItems = [];
  activeTab: string;
  schoolImg: string;
  schoolName: string;
  userName: string;
  moduleName: string;
  userId;
  currentUserKeys = ['name', 'image_path', 'gender', 'national_id', 'country_code', 'phone', 'email'];
  isBeta;
  showToggleIcon = false;
  destroy$ = new Subject<void>();

  ngOnInit() {
    this.activeModule = window.location.pathname.split('/')[1];
    this.userPlan = this.userService.userPlan;
    if (this.userPlan === null) {
      this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.userService.userPlan = res[0]?.subscription_plan?.is_free == 0 ? 'paid' : 'free';
        this.userPlan = this.userService?.userPlan;
      })
    }
  }

  getRoute(moduleName) {

    if (moduleName === this.router.url.split('/')[1]) {
      // return `/${moduleName}/${this.router.url.split('/')[2]}`
    }
    else {
      return `/${moduleName}/${this.getDefautlRoutesForModuels(moduleName)}`
    }
  }

  getDefautlRoutesForModuels(sectionName) {
    let result;
    switch (sectionName) {
      case 'dashboard':
        result = 'students';
        break;
      case 'messages':
        result = 'messages-list';
        break;
      case 'messages-new':
        result = 'view-messages';
        break;
      case 'buses':
        result = 'students';
        break;
      case 'reports':
        result = 'dashboard';
        break;
      case 'reports-new':
        result = 'dashboard';
        break;
      case 'calling-screen':
        result = 'calling-screen';
        break;
      case 'school-management':
        result = 'school-info';
        break;
      case 'names-sounds':
        result = '';
        break;
      case 'grade-management':
        result = 'grades';
        break;
      case 'delegation':
        result = 'listing';
        break;
      case 'attendance':
        result = 'attendance-dashboard';
        break;
      case 'appointments':
        result = 'requests';
        break;
      case 'data-management':
        result = 'students';
        break;
      default:
        break;
    }
    return result;
  }

  amplitudeEventHandler(tab) {
    switch (tab) {
      case 'dashboard':
        this.amplitudesService.trackEvent('CTA.Sidenav.Dashboard', {})
        break;
      case 'school-management':
        this.amplitudesService.trackEvent('CTA.SideNav.SchoolManagement', {})
        break;
      default:
        break;
    }
  }

  ngOnDestroy(): void {
  }
}
